import React from "react";
import moment from "moment";
import { CONSTANTS } from "../shared/constants";
import { useNavigate } from "react-router-dom";
import { Favourite, Info, NotFavourite } from "../icons";
import { useSelector } from "react-redux";
import { AddVehicleToFavorites } from "../services/btc-api.service";
import { initUserSession } from "../services/auth.service";
import { toast } from "react-toastify";

const Table = ({ rows, style, rowColor, isMobile }) => {
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const imageBasePath =
    window.location.protocol + "//" + window.location.host + "/";
  const getDate = (date) => {
    if (date) {
      const japanDateTime = moment(date).format("YYYY-MM-DD");

      return japanDateTime;
    }

    return "";
  };
  const handleClick = (_id) => {
    navigate(`/car-details/${_id}`);
  };

  const addFavorite = async (vehicleId, auctionType) => {
    try {
      if (user && user._id) {
        await AddVehicleToFavorites(user._id, {
          vehicleId: vehicleId,
          auctionType: auctionType,
        });
        await initUserSession();
        toast.info("Removed from the favorite list")

        // window.location.reload();
      } else {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error adding vehicle to favorites:", error);
    }
  };

  return (
    <>
      {isMobile === false && (
        <div className="auction-table" style={style}>
          <div className="thead">
            <div>Photo</div>
            <div>Goods Name</div>
            <div>Other Details</div>
            <div>Goods Price</div>
            <div>Due In Place</div>
            <div>Auc. Info</div>
          </div>
          {rows &&
            rows.map((row, index) => (
              <div
                className={`table-row ${index % 1 === 0 ? row?.isFavorite ? "even-row-favorite-row" : "odd-row-favorite-row" : null
                  }`}
              >
                {rowColor && (
                  <span
                    onClick={() =>
                      addFavorite(row?.vehicle?._id, row?.vehicle?.auctionType)
                    }
                    className="row-color"
                  >
                    <div className="rotate-text-fvrt">
                      {" "}
                      <img
                        style={{ height: 22, width: 22, marginRight: 15 }}
                        src={imageBasePath + "start-round.png"}
                      />{" "}
                      Remove
                    </div>
                  </span>
                )}
                <div className="no-border">
                  <img
                    src={`${process.env.REACT_APP_BTC_API_URL}/${row?.vehicle?.thumbnail}`}
                    alt={`${process.env.REACT_APP_BTC_API_URL}/${row?.vehicle?.thumbnail}`}
                    onClick={() => handleClick(row?.vehicle?._id)}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <div>
                  <p className="bold-and-black">
                    <b
                      onClick={() => handleClick(row?.vehicle?._id)}
                      style={{ cursor: "pointer" }}
                    >
                      {row?.vehicle?.name}
                    </b>
                  </p>
                  <div>
                    <p style={{ padding: 10 }}>{row?.vehicle?.year}</p>
                    <p style={{ padding: 10 }}>
                      {row?.vehicle?.mileage?.toLocaleString()} km
                    </p>
                  </div>
                  {row?.otherDetails?.map((detail, i) => (
                    <p key={i}>{detail}</p>
                  ))}
                </div>
                <div className="details">
                  <p>{row?.vehicle?.fuel}</p>
                  <p>
                    {row?.vehicle?.transmission}{" "}
                    {row?.vehicle?.displacement?.toLocaleString()} cc
                  </p>
                  <p>
                    <span className="bold-and-black">Engine:</span>{" "}
                    {row?.vehicle?.engineType}
                  </p>
                  {row?.vehicle?.condition === "DAMAGE" && (
                    <button className="damaged"> Damage</button>
                  )}
                  {row?.vehicle?.condition === "USED" && (
                    <button className="used"> Used</button>
                  )}
                </div>
                <div>
                  <p className="bold-and-black">
                    <b>{row?.vehicle?.discountPrice.toLocaleString()} Yen</b>
                  </p>
                </div>
                <div>
                  <span>{row?.vehicle?.currentAddress}</span>
                </div>
                <div>
                  <span className="bold-and-black">
                    <b
                      onClick={() => handleClick(row?.vehicle?._id)}
                      style={{ cursor: "pointer" }}
                    >
                      NO. {row?.vehicle?.auctionNo}
                    </b>
                  </span>
                  <span className="bold-and-black">
                    <b>
                      {row?.vehicle?.auctionType ===
                        CONSTANTS.AUCTION_TYPES.NEGOTIATION
                        ? "NEGOTIATION"
                        : row?.vehicle?.auctionType}
                    </b>
                  </span>
                  <span>{getDate(row?.vehicle?.auctionEndDate)}</span>
                </div>
              </div>
            ))}
        </div>
      )}

      {isMobile &&
        rows.map((cards, i) => {
          return (
            <div key={i} className="mainCardslistSearch">
              <div className="containerSearchcards">
                <div className="searchimagecontainer">
                  <img
                    className="search-Imglist"
                    src={`${process.env.REACT_APP_BTC_API_URL}/${cards?.vehicle?.thumbnail}`}
                    alt={`${process.env.REACT_APP_BTC_API_URL}/${cards?.vehicle?.thumbnail}`}
                  />
                </div>
                <div className="cardscontentcontainer">
                  <div className="contentSearch">
                    <a
                      style={{ marginTop: 8, fontSize: 11, fontWeight: 800 }}
                      href="#auctionno"
                    >
                      No.{cards?.vehicle?.auctionNo}
                    </a>

                    <div className="damagedUsedContainer">
                      {cards?.vehicle?.condition === "DAMAGE" && (
                        <button className="damagedcard">
                          <span className="some_thing">Damaged</span>
                        </button>
                      )}
                      {cards?.vehicle?.condition === "USED" && (
                        <button className="usedcard">
                          <span className="some_thing">Used</span>
                        </button>
                      )}
                      <div className="iconContainer">
                        {cards?.vehicle?.isFavorite === true ? (
                          <Favourite
                            style={{ width: 17, height: 17, marginTop: 1 }}
                          />
                        ) : (
                          <NotFavourite
                            style={{ width: 17, height: 17, marginTop: 1 }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: -7 }}>
                    <span
                      onClick={() => handleClick(cards?.vehicle?._id)}
                      className="cardNameSearch"
                    >
                      {cards?.vehicle?.name}
                    </span>
                  </div>
                  <div style={{ marginTop: -5 }}>
                    <span
                      style={{
                        color: "#dc0000",
                        fontWeight: "bold",
                        fontSize: 12,
                      }}
                    >
                      {cards?.vehicle?.discountPrice.toLocaleString()} Yen
                    </span>
                  </div>
                  <span style={{ display: "flex" }}>
                    <b style={{ fontSize: 10, color: "black" }}>
                      {cards?.vehicle?.auctionType ===
                        CONSTANTS.AUCTION_TYPES.NEGOTIATION
                        ? "NEGOTIATION: "
                        : `${cards?.vehicle?.auctionType} : `}
                    </b>
                    <span className="auctionendDate">
                      {getDate(cards?.vehicle?.auctionEndDate)}
                    </span>
                  </span>
                  <div style={{ display: "flex", marginTop: 2 }}>
                    <b style={{ fontSize: 10 }}>Location : </b>
                    <b className="currentAddressSearch">
                      {" "}
                      {cards?.vehicle?.currentAddress}{" "}
                    </b>
                    <Info className="infoIcon" />
                  </div>
                  <div>
                    <p className="detailsofVehicle">
                      {cards?.vehicle?.year} &nbsp; | &nbsp;&nbsp;{" "}
                      {cards?.vehicle?.mileage?.toLocaleString()} km &nbsp; |
                      &nbsp;&nbsp;
                      {cards?.vehicle?.displacement?.toLocaleString()} cc &nbsp;
                      | &nbsp;&nbsp;
                      {cards?.vehicle?.fuel}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default Table;
